import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { useHistory } from 'react-router';
import { useTranslation } from 'react-i18next';
import { makeStyles } from '@material-ui/core/styles';
import { Helmet } from 'react-helmet';
import TermsPage from '../../shared/TermsPage';
import { parseJwt } from '../../../app/utils';
import { getDisplayData, getIsBind } from '../../../features/ecBindingSlice';
import { openModal, closeModal } from '../../../features/modalSlice';
import { ModalType } from '../../../app/types';

const useStyles = makeStyles(
  {
    root: {
      maxWidth: 375,
      margin: 'auto',
      height: '100vh',
    },
  },
  {
    name: 'TermsContainer',
  },
);

const TermsContainer = () => {
  const classes = useStyles();
  const location = useLocation();
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const history = useHistory();
  const { display } = useSelector(store => store.ecBinding);
  const [isCheck, setIsCheck] = useState(false);
  const query = new URLSearchParams(location.search);
  const token = query.get('access_token') || '';
  const customerId = query.get('customerId') || '';
  const { orgId, lineAccountId, provider } = parseJwt(token) || {};

  const handleNext = () => {
    if (isCheck) {
      history.push(`/${provider}/bind${location.search}`);
    }
  };

  useEffect(() => {
    if (!display && token) {
      dispatch(getDisplayData(orgId, provider, token));
    }
  }, [display, token]);

  useEffect(() => {
    const checkIsBind = async () => {
      const isBind = await dispatch(
        getIsBind(orgId, customerId, token, provider),
      );

      if (token && isBind) {
        dispatch(
          openModal({
            modalType: ModalType.AWARD_MODAL,
            modalProps: {
              title: t('ecBinding:bind-error-repeat'),
              onClick: () => {
                window.location.href = `https://line.me/R/ti/p/${lineAccountId}`;
                dispatch(closeModal());
              },
              submitText: t('ecBinding:bind-error-repeat-btn'),
            },
          }),
        );
      }
    };

    checkIsBind();
  }, [token]);

  return (
    <div className={classes.root}>
      <Helmet>
        <title>{display?.policy?.pageTitle || t('ecBinding:termsPage')}</title>
      </Helmet>
      <TermsPage
        data={display}
        isCheck={isCheck}
        setIsCheck={value => {
          setIsCheck(value);
        }}
        onNext={handleNext}
      />
    </div>
  );
};

export default TermsContainer;
